import { VmsPluginCameraStream } from '@/api/models/VmsPluginCamerasRequest';
import { arrayOf, object } from 'vue-types';

export function defineStreamsProp() {
  return arrayOf(object<VmsPluginCameraStream>()).isRequired;
}
